import IconError from '@fortuneo/ui-icons/general/IconError'
import React, { type FC, type PropsWithChildren, useCallback } from 'react'
import {
  ErrorBoundary as ReactErrorBoundary,
  type ErrorBoundaryPropsWithFallback,
} from 'react-error-boundary'

export enum ErrorMappingMsg {
  ErrorContentfulTooMuchContentArticles = 'Cette section prend 4 contents Articles',
  ErrorContentfulContentArticlesLengthBetween3And4 = 'Cette section prend 3 ou 4 contents Articles',
  ErrorContentfulGraphGroup = 'Deux graphs du même graphGroup doivent avoir les mêmes labels',
  ErrorContentfulInformationalPageModel = "Une page informationnelle ne peut pas avoir d'offre / d'image dans le hero",
}
const ErrorFallback: FC<{ error: any }> = ({ error }) => (
  <div className="flex items-center rounded bg-theme-error-accent1 px-3 py-4 text-085">
    <IconError className="mr-2.5 fill-theme-error-main" />
    Composant non valide : {error?.code || 'Erreur inconnue'}
  </div>
)

// https://github.com/bvaughn/react-error-boundary
export const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const onError: ErrorBoundaryPropsWithFallback['onError'] = useCallback(
    (error, info) => {
      console.error(error, info)
    },
    []
  )

  return (
    <ReactErrorBoundary FallbackComponent={ErrorFallback} onError={onError}>
      {children}
    </ReactErrorBoundary>
  )
}
